import { useTranslation } from 'react-i18next';

import SecondaryPageLayout from '@/Layout/SecondaryPageLayout';
import useNativeSignIn from '@/hooks/use-native-sign-in';
import usePrefilledIdentifier from '@/hooks/use-prefilled-identifier';
import { useForgotPasswordSettings } from '@/hooks/use-sie';
import { identifierInputDescriptionMap } from '@/utils/form';

import ErrorPage from '../ErrorPage';

import EvaForgotPassword from './EvaForgotPassword';
import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPassword = () => {
  const { isForgotPasswordEnabled, enabledMethodSet } = useForgotPasswordSettings();
  const native = useNativeSignIn();
  const { t } = useTranslation();
  const enabledMethods = [...enabledMethodSet];
  const { value: prefilledValue } = usePrefilledIdentifier({
    enabledIdentifiers: enabledMethods,
    isForgotPassword: true,
  });

  if (!isForgotPasswordEnabled) {
    return <ErrorPage />;
  }

  // 原生模式使用上游多页流，EVA 国内版保持定制的单页重置。
  if (!native) {
    return <EvaForgotPassword />;
  }

  return (
    <SecondaryPageLayout
      title="description.reset_password"
      description="description.reset_password_description"
      descriptionProps={{
        types: enabledMethods.map((method) => t(identifierInputDescriptionMap[method])),
      }}
    >
      <ForgotPasswordForm autoFocus defaultValue={prefilledValue} enabledTypes={enabledMethods} />
    </SecondaryPageLayout>
  );
};

export default ForgotPassword;
